import React from "react";
import "./css/footer.css";
import First from "../assets/public/pp-1.webp";
import Second from "../assets/public/pp-2.webp";
import Third from "../assets/public/pp-3.webp";
import Fourth from "../assets/public/pp-4.webp";
import Fifth from "../assets/public/pp-5.webp";
import Sixth from "../assets/public/pp-6.webp";

const Footer = () => {
  return (
    <div className="participants-container">
      <h1>OUR PAST PARTICIPANTS</h1>
      <div className="participants-grid">
        <img src={First} alt="Participant A" />
        <img src={Second} alt="Participant B" />
        <img src={Third} alt="Participant C" />
        <img src={Fourth} alt="Participant D" />
        <img src={Fifth} alt="Participant E" />
        <img src={Sixth} alt="Participant F" />
      </div>

      <div className="text">
        <p className="register-text">To register click: </p>
        <button
          className="register-button"
          onClick={() =>
            window.open("https://my.moodi.org/competitions", "_blank")
          }
        >
          my.moodi.org/competitions
        </button>
      </div>
    </div>
  );
};

export default Footer;
